import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import styled from "styled-components";

const Element = styled.div`
  transition: height 200ms;
`;

export interface AnimateHeightRef {
  update: () => void;
}

const AnimateHeight = forwardRef<
  AnimateHeightRef,
  {
    className?: string;
    children?: React.ReactNode;
  }
>((props, ref) => {
  const { className, children } = props;
  const [height, setHeight] = useState<string | number>("auto");
  const contentDiv = useRef<HTMLDivElement | null>(null);

  const getCurrentHeight = () => {
    const element = contentDiv.current as HTMLDivElement;

    let childHeight = 0;
    let previousMargin = 0;
    element.childNodes.forEach((node) => {
      if (node instanceof HTMLElement) {
        const styles = window.getComputedStyle(node);
        const marginTop = parseFloat(styles["marginTop"]);
        const marginBottom = parseFloat(styles["marginBottom"]);
        if (marginTop > previousMargin) {
          childHeight += marginTop - previousMargin;
        }
        previousMargin = marginBottom;
        childHeight += node.scrollHeight + marginBottom;
      }
    });

    return childHeight;
  };

  useImperativeHandle(ref, () => ({
    update: () => {
      const currentHeight = getCurrentHeight();
      setHeight(currentHeight);

      setTimeout(() => {
        const currentHeight = getCurrentHeight();
        setHeight(currentHeight);

        setTimeout(() => {
          setHeight("auto");
        }, 200);
      });
    },
  }));

  return (
    <Element style={{ height }} className={className} ref={contentDiv}>
      {children}
    </Element>
  );
});

export default AnimateHeight;
